// extracted by mini-css-extract-plugin
export default {"wrapper":"EditPanel-module__wrapper--d7a22","editor":"EditPanel-module__editor--c3879","divider":"EditPanel-module__divider--febcf","copy":"EditPanel-module__copy--f33ad"};